class FormCheckbox {
  constructor(el,opt){
    this.el = el;
    if($("." + this.el).length > 0){
      this.event();
    }
  }
  event(){
    const checkBox = document.querySelector('.mwform-checkbox-field-text');
    checkBox.innerHTML = `<span><a href="https://betrading.jp/saiyou/policy/" name="consent" target="_blank" class="policy-link">プライバシーポリシー</a>に同意する</span>`
  }
}
